import { useCallback, useState } from 'react'

import { useUnit } from 'effector-react'

import { Page } from '@/components/layout/page/page'
import { usePaginationState } from '@/components/ui/table/hooks/usePaginationState'
import { DIALOG_TYPE } from '@/dialogs/constants'
import { $creatorId } from '@/models/creators.ts'
import { openDialog } from '@/models/dialogs'
import { NoSpenderHeaderButtons } from '@/modules/creator-settings/lists/no-spenders/components/no-spender-header-buttons'
import { NoSpendersTable } from '@/modules/creator-settings/lists/no-spenders/components/no-spenders-table'
import { useNoSpenderListMutations } from '@/modules/creator-settings/lists/no-spenders/hooks/useGetNoSpenderListMutations'
import { useGetNoSpenderLists } from '@/modules/creator-settings/lists/no-spenders/hooks/useGetNoSpenderLists'
import type { NoSpendersListFormValues } from '@/modules/creator-settings/lists/no-spenders/types'

export const NoSpendersView = () => {
  const creatorId = useUnit($creatorId)
  const { paginationState, setPaginationState } = usePaginationState({
    pageIndex: 0,
    pageSize: 10,
  })

  const [searchQuery, setSearchQuery] = useState('')
  const { createNoSpenderList } = useNoSpenderListMutations(creatorId ?? 0)
  const { data, isFetching, pageCount } = useGetNoSpenderLists(
    creatorId ?? 0,
    paginationState,
    searchQuery,
  )

  const handleCreate = useCallback(
    async (values: NoSpendersListFormValues) => {
      return createNoSpenderList.mutateAsync({
        name: values.name,
        days: values.minimumDays,
      })
    },
    [createNoSpenderList],
  )

  const handleNewListPress = useCallback(() => {
    openDialog({
      type: DIALOG_TYPE.NO_SPENDER_LIST_FORM,
      onSubmit: handleCreate,
      title: 'Create a custom No Spenders List',
      submitLabel: 'Create',
    })
  }, [handleCreate])

  return (
    <Page
      title="No Spenders Lists"
      description="See the list of fans who haven't spent any money on the chosen creator account"
      headerOptions={
        <NoSpenderHeaderButtons
          onNewListPress={handleNewListPress}
          setFilter={setSearchQuery}
        />
      }
    >
      <NoSpendersTable
        paginationState={paginationState}
        onPaginationChange={setPaginationState}
        data={data}
        isFetching={isFetching}
        pageCount={pageCount}
      />
    </Page>
  )
}
